import React from 'react';
import { connect } from 'react-redux';
import throttle from 'lodash.throttle';
import {
  isTablet,
  fireCustomDimension,
  getCustomDimension45,
  inViewForReact,
} from 'utils/common';
import { setGrxParams } from 'utils/setGrxData';
import { openSidebar } from 'reduxUtils/modules/comments';
import { loadPhotostoryData } from 'routes/photostory/redux';
import smoothScroll from 'smoothscroll';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { setPageConfigAndSendIBeatCall } from 'utils/iBeatConfig';
import { earnAboundPoints } from 'components_v2/common/Abound/redux';
import LoadableComponentLoader from 'components_v2/common/LoadableComponentLoader/LoadableComponentLoader';
import StickyHeader from '../../components/StickyHeader/StickyHeader';
import Photostory from './Photostory';
// eslint-disable-next-line no-unused-vars
import s from './Photostory.scss';
import InViewObserver from '../../../../components/InViewObserver/InViewObserver';

// const render = 0;
class PhotostoryWrapper extends React.Component {
  // replace this.state.finalNextLinks with nextLinksData
  constructor(props) {
    super(props);

    this.state = {
      activePhotostoryMsid: '',
      textSize: 'medium',
      nextPhotostoryIndex: 1,
    };
    this.articlesLoaded = false;
    this.scrollVal = 0;
    this.lastDataFetchIndex = -1;
    this.pageViewFiredArr = [];
    this.tpActivityFired = false;
    this.mainArticlePageViewGASent = false;
    this.scrollDepthAcheivedArr = [];
    this.lastArticleLoadedIndex = 0;
  }

  onSizeChange = currSize => {
    const _classes = ['small', 'medium', 'large'];
    const ele = document.querySelector('html');
    if (!ele.classList.contains(currSize)) {
      // remove all classes first and add newone
      _classes.map(x => ele.classList.remove(x));
      ele.classList.add(currSize);
    }
    this.setState({
      textSize: currSize,
    });
  };

  changePageMeta = (msid, index) => {
    const { photostories } = this.props;
    if (!photostories[msid] || !photostories[msid].wu) {
      return;
    }

    // const event = new Event('ARTICLECHANGEPERPECWEB');
    // window.dispatchEvent(event);

    let nextDataUrl = photostories[msid].wu;
    nextDataUrl = nextDataUrl
      .replace('https://timesofindia.indiatimes.com', '')
      .replace('https://toidev.indiatimes.com', '');
    let queryParameters = window.location.href.split('?')[1];
    if (queryParameters) {
      const queryParams = queryParameters.split('&').map(param => {
        // If 'picid' is found, replace its value
        if (param.startsWith('picid=')) {
          return '';
        }
        return param;
      });
      queryParameters = queryParams.join('&');
    }

    nextDataUrl += queryParameters ? `?${queryParameters}` : '';

    window.history.pushState({}, '', nextDataUrl);
    if (photostories[msid].seo) {
      const htmltagsRegex = /(<([^>]+)>)/gi;
      let docTitle = photostories[msid].seo.title;
      if (typeof docTitle === 'string') {
        docTitle = docTitle.replace(htmltagsRegex, '');
      }

      document.title = docTitle;
    } else if (
      photostories[msid] &&
      photostories[msid].wu &&
      photostories[msid].wu.includes('/spotlight') &&
      photostories[msid].hl
    ) {
      document.title = photostories[msid].hl;
    }
    console.log(index);

    // setGrxParamsRelatedToData(photostories[msid], {
    //   onPlatformSource: 'ArticleShowPerpetualScroll',
    //   contentType: 'articleshow',
    // });
    if (
      typeof window !== 'undefined' &&
      window.persObj &&
      typeof window.persObj.setObserver === 'function'
    ) {
      window.persObj.setObserver();
    }
    if (
      typeof window !== 'undefined' &&
      typeof window.perpetualAdRefresh === 'function'
    ) {
      window.perpetualAdRefresh('mweb');
    }
  };

  changePageUrl = (nextElement, scrollingDown, elemMsid) => {
    const { nextLinksData, photostories, photostoryMsid } = this.props;

    const elem = document.querySelector(`[data-articlemsid="${elemMsid}"]`);
    if (!elem) {
      return;
    }
    const skew = -200;
    const isElementInView = inViewForReact(elem, skew, true);
    const origin = `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? `:${window.location.port}` : ''
    }`;
    const pageUrl = window.location.href.replace(origin, '');
    let activeMsid;
    let currentIndex;
    let nextPhotostoryIndex = 1;
    if (scrollingDown) {
      const currentPopIndex = nextElement.getAttribute('data-linkindex');
      if (!isNaN(currentPopIndex)) {
        nextPhotostoryIndex = parseInt(currentPopIndex, 10) + 1;
      }
    }
    if (isElementInView && nextLinksData && nextLinksData.length > 0) {
      let nextDataUrl;
      if (scrollingDown) {
        currentIndex = nextElement.getAttribute('data-linkindex');
        if (nextLinksData[currentIndex] && nextLinksData[currentIndex].wu) {
          nextDataUrl = nextLinksData[currentIndex].wu.replace(
            'https://timesofindia.indiatimes.com',
            '',
          );
        } else if (
          nextLinksData[currentIndex] &&
          nextLinksData[currentIndex].url
        ) {
          nextDataUrl = `/${nextLinksData[currentIndex].url}/photostory/${
            nextLinksData[currentIndex].msid
          }.cms`;
        }

        activeMsid = nextLinksData[currentIndex].msid;
        if (currentIndex && parseInt(currentIndex, 10) >= 3) {
          return;
        }
      } else {
        currentIndex =
          parseInt(nextElement.getAttribute('data-prevlinkindex'), 10) + 1;
        if (currentIndex === -1) {
          nextDataUrl = photostories[photostoryMsid].wu;
          activeMsid = photostoryMsid;
        } else {
          // nextDataUrl = nextLinksData[currentIndex].wu
          //   .replace('https://timesofindia.indiatimes.com', '')
          //   .replace('https://toidev.indiatimes.com', '');

          if (nextLinksData[currentIndex] && nextLinksData[currentIndex].wu) {
            nextDataUrl = nextLinksData[currentIndex].wu
              .replace('https://timesofindia.indiatimes.com', '')
              .replace('https://toidev.indiatimes.com', '');
          } else if (
            nextLinksData[currentIndex] &&
            nextLinksData[currentIndex].url
          ) {
            nextDataUrl = `/${nextLinksData[currentIndex].url}/photostory/${
              nextLinksData[currentIndex].msid
            }.cms`;
          }
          activeMsid = nextLinksData[currentIndex].msid;
        }

        nextDataUrl = nextDataUrl
          .replace('https://timesofindia.indiatimes.com', '')
          .replace('https://toidev.indiatimes.com', '');
      }

      if (pageUrl !== nextDataUrl) {
        this.setState({
          activePhotostoryMsid: activeMsid,
        });
        // this.props.updateActiveMsid(activeMsid);
        // this.props.updateOpenAppUrl(this.getAppLink());
        this.changePageMeta(activeMsid, currentIndex);
        // setPageConfigAndSendIBeatCall(
        //   photostories[activeMsid],
        //   this.props.isWapView,
        // );
        // this.fireComscore();
      }
    }

    if (scrollingDown) {
      this.setState({ nextPhotostoryIndex });
    }
  };

  monitorScroll = throttleTime =>
    throttle(this.handleScrollEvent, throttleTime);

  handleScrollEvent = () => {
    const { nextLinksData } = this.props;
    let scrollingDown = false;
    const activeMsid =
      this.state.activePhotostoryMsid || this.props.photostoryMsid;
    let nextElement;
    let elemMsid;
    let linkObj;

    // changing the msid in tgtkeys for perpetual scroll
    if (window.tgtkeys) {
      window.tgtkeys.msid = activeMsid;
    }
    // if (!this.articlesLoaded && !this.props.dataLoading) {
    //   this.loadRelatedArticlesOnPerpetual();
    // }
    const currentScrollVal = window.pageYOffset;
    if (currentScrollVal > this.scrollVal) {
      scrollingDown = true;
    }

    if (scrollingDown) {
      nextElement = document.querySelector(`#next-story-${activeMsid}`);
      if (!nextElement) {
        return;
      }
      const nextLinkIndex = nextElement.getAttribute('data-linkindex');
      if (Array.isArray(nextLinksData) && nextLinksData.length > 0) {
        linkObj = nextLinksData[nextLinkIndex];
      }
      if (linkObj && linkObj.msid) {
        elemMsid = linkObj.msid;
      }
    } else if (
      !scrollingDown &&
      activeMsid !== this.props.photostoryMsid &&
      Array.isArray(nextLinksData) &&
      nextLinksData.length > 0
    ) {
      const prevSelector = document.querySelector(`#next-story-${activeMsid}`);
      if (!prevSelector) {
        return;
      }
      const prevLinkIndex = prevSelector.getAttribute('data-prevlinkindex');
      if (prevLinkIndex === '-2') {
        return;
      }
      const prevMsid =
        prevLinkIndex === '-1'
          ? this.props.photostoryMsid
          : nextLinksData[prevLinkIndex].msid;
      nextElement = document.querySelector(`#next-story-${prevMsid}`);
      elemMsid = prevMsid;
    }
    if (!scrollingDown && this.state.nextPhotostoryIndex !== -1) {
      this.setState({ nextPhotostoryIndex: -1 });
    }
    this.scrollVal = currentScrollVal;
    if (nextElement) {
      this.changePageUrl(nextElement, scrollingDown, elemMsid);
    }
    // this.handleGAOnScroll();
  };

  openPSSideBar = (msid, id) => {
    if (isTablet()) {
      const sidebar = document.getElementById(`comment-container-${msid}`);
      if (sidebar) {
        const val =
          window.pageYOffset + sidebar.getBoundingClientRect().top - 100;
        smoothScroll(val, 500);
      }
      return;
    }
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = '';
    this.props.openSidebar(msid, id);
  };

  handleMainArticleTPandGA = () => {
    const { parentPhotostoryData, photostoryMsid } = this.props;
    if (!this.mainArticlePageViewGASent) {
      if (
        this.props.photostories &&
        this.props.msid &&
        this.props.photostories[this.props.msid] &&
        this.props.photostories[this.props.msid].metaInfo &&
        this.props.photostories[this.props.msid].metaInfo.Contenttype
      ) {
        fireCustomDimension(
          this.props.photostories[this.props.msid].metaInfo.Contenttype,
          'dimension61',
        );
      }
      if (window.TimesGA && window.TimesGA.setGAParams) {
        window.TimesGA.setGAParams({
          dimension8: this.props.customDimension8,
          dimension9: 'photostory_withblocker',
        });
        window.pageViewSource = 'registrationwall';
      }
      if (
        typeof window !== 'undefined' &&
        window.sessionStorage &&
        sessionStorage.getItem('planName')
      ) {
        fireCustomDimension(sessionStorage.getItem('planName'), 'dimension33');
      }
      fireCustomDimension(photostoryMsid, 'dimension31');
      if (parentPhotostoryData && parentPhotostoryData.dl) {
        fireCustomDimension(
          getCustomDimension45(parentPhotostoryData.dl),
          'dimension55',
        );
      }

      analyticsWrapper('ga', 'send', 'pageview', parentPhotostoryData?.wu);

      this.mainArticlePageViewGASent = true;
    }
  };

  getCommentsData = msid => {
    let commentCount = 0;
    if (this.props.comments && this.props.comments[`commentsData-${msid}`]) {
      const commentsData = this.props.comments[`commentsData-${msid}`];
      commentCount =
        Array.isArray(commentsData) && commentsData[0]
          ? commentsData[0].totalcount
          : 0;
    }

    return commentCount;
  };

  getComments = msid => {
    let comments = [];
    if (
      this.props.comments &&
      this.props.comments[`commentsData-${msid}-agreed`]
    ) {
      comments = this.props.comments[`commentsData-${msid}-agreed`];
      if (!(Array.isArray(comments) && comments.length)) {
        comments = [];
      }
    }

    return comments;
  };

  getArticleSectionName = msid => {
    const { photostories } = this.props;
    const photostory = photostories[msid];
    const sectionName =
      photostory &&
      photostory.navsubsecs &&
      photostory.navsubsecs.subsec1 &&
      photostory.navsubsecs.subsec1.subsecname1
        ? photostory.navsubsecs.subsec1.subsecname1
        : '';

    return sectionName;
  };

  loadPerpetualPhotostories = linkData => {
    const { photostories } = this.props;

    if (
      linkData &&
      linkData.msid &&
      photostories &&
      !photostories[linkData.msid] &&
      typeof this.props.loadPhotostoryData === 'function'
    ) {
      this.props.loadPhotostoryData(
        {
          fullPath: `/photostory/${linkData.msid}.cms`,
          isWapView: false,
          photostoryMsid: linkData.msid,
        },
        this.props.isAppView,
      );
    }
  };

  componentDidMount() {
    const { parentPhotostoryData, isWapView } = this.props;
    if (!this.props.isAppView) {
      window.addEventListener('scroll', this.monitorScroll());
    }

    //todo: set grx param make customizations
    setGrxParams(parentPhotostoryData, {
      contentType: 'photostory',
    });

    setPageConfigAndSendIBeatCall(parentPhotostoryData, isWapView);

    this.handleMainArticleTPandGA();

    analyticsWrapper(
      'grx',
      'send',
      'event',
      window.categoryForGA,
      'landing',
      `story_0-${window.location.href}`,
      { nonInteraction: 1 },
    );
    if (
      parentPhotostoryData &&
      parentPhotostoryData.metaInfo &&
      typeof parentPhotostoryData.metaInfo === 'object' &&
      parentPhotostoryData.metaInfo.Contenttype
    ) {
      fireCustomDimension(
        parentPhotostoryData.metaInfo.Contenttype,
        'dimension61',
      );
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.monitorScroll());
  }

  render() {
    const {
      parentPhotostoryData,
      photostoryMsid,
      navigation,
      photostories,
      nextLinksData,
      isAppView,
      isWapView,
      isUserPrime,
      // seoData,
    } = this.props;

    let photostoryTitle = parentPhotostoryData.hl;
    const htmltagsRegex = /(<([^>]+)>)/gi;

    if (typeof photostoryTitle === 'string') {
      photostoryTitle = photostoryTitle.replace(htmltagsRegex, '');
    }

    const breadCrumbData =
      navigation && navigation.breadcrumbs ? navigation.breadcrumbs : [];

    return (
      <React.Fragment>
        <StickyHeader
          // setIsStickyHeaderVisible={this.setIsStickyHeaderVisible}
          msid={photostoryMsid}
          isParent={false}
          url={parentPhotostoryData.seo && parentPhotostoryData.seo.canonical}
          // url={seoData && seoData.canonical}
          title={photostoryTitle}
          isWapView={false}
          isAppView={isAppView}
          // image={
          //   articleshowDataActive.images
          //     ? articleshowDataActive.images[0]
          //     : undefined
          // }
          openSidebar={this.openPSSideBar}
          commentsCount={this.getCommentsData(photostoryMsid)}
          wu={parentPhotostoryData.seo && parentPhotostoryData.seo.canonical}
          // wu={seoData && seoData.canonical}
          via="@timesofindia"
          isTablet={isTablet}
          sticky
          enableStickyBehavior
        />
        <div
          id={`toi-article-container-${photostoryMsid}`}
          className="clearfix rel"
          // data-scrollga={`${categoryForGA}#scroll#scroll_starts`}
          data-translate-id="cw"
          data-translate-page="1"
        >
          <LoadableComponentLoader
            loadInView
            loadableComponentName="VideoActionControllerWeb"
            activeMsid={this.state.activePhotostoryMsid}
            msid={this.props.msid}
            isTablet={isTablet}
          />
          {/* Inner component */}
          <Photostory
            photostoryData={parentPhotostoryData}
            msid={photostoryMsid} // change this to active
            parentMsid={photostoryMsid}
            isAppView={isAppView}
            isWapView={isWapView}
            isUserPrime={isUserPrime}
            sidebarData={this.props.sidebarData}
            textSize={this.state.textSize}
            onSizeChange={this.onSizeChange}
            breadCrumbData={breadCrumbData}
            breadCrumbTitle={photostoryTitle}
            topSearches={this.props.topSearches}
            articleIndex={0}
            isTablet={isTablet}
            commentsCount={this.getCommentsData(photostoryMsid)}
            commentsData={this.getComments(photostoryMsid)}
            sectionName={this.getArticleSectionName(photostoryMsid)}
            isPrivateUser={this.props.isPrivateUser}
            openSideBar={this.openPSSideBar}
            showFontAlterOptions // make this false for perpetual ones
            rhsWidgetPriorityPS={this.props.rhsWidgetPriorityPS}
            currentCountry={this.props.currentCountry}
            rhsWidgetVideoAutoplay={this.props.rhsWidgetVideoAutoplay}
            articleWidget={this.props.articleWidget}
            photostoryWidget={this.props.photostoryWidget}
            isEtimesPhotostory={this.props.isEtimesPhotostory}
            navsubsecs={parentPhotostoryData.navsubsecs}
            isAdRemoved={this.props.isAdRemoved}
            bottomWidgets={this.props.widgets}
            earnPoints={this.props.earnPoints}
            user={this.props.userData}
          />

          {Array.isArray(nextLinksData) && nextLinksData.length
            ? nextLinksData.map((val, index) => (
                <div
                  id={`toi-article-container-${val.id || val.msid}`}
                  className="clearfix rel"
                  key={val.id || val.msid}
                >
                  <div className="perpetual" />
                  <div
                    id={`next-story-${
                      index === 0
                        ? this.props.msid
                        : nextLinksData[index - 1].msid
                    }`}
                    data-linkindex={`${index}`}
                    data-prevlinkindex={`${index - 2}`}
                  />
                  {(index === 0 ||
                    (photostories &&
                      nextLinksData[index - 1] &&
                      nextLinksData[index - 1].msid &&
                      photostories[nextLinksData[index - 1].msid])) && (
                    <InViewObserver
                      inViewCallback={() => {
                        this.loadPerpetualPhotostories(val);
                        console.log('inview:,', index);
                      }}
                      viewMargin="500px 0px 500px 0px"
                    />
                  )}

                  {photostories &&
                    photostories[val.msid] && (
                      <>
                        <Photostory
                          photostoryData={photostories[val.msid]}
                          msid={val.id || val.msid} // change this to active
                          parentMsid={photostoryMsid}
                          isAppView={isAppView}
                          isWapView={isWapView}
                          isUserPrime={isUserPrime}
                          sidebarData={this.props.sidebarData}
                          textSize={this.state.textSize}
                          onSizeChange={this.onSizeChange}
                          breadCrumbData={breadCrumbData}
                          breadCrumbTitle={photostoryTitle}
                          topSearches={this.props.topSearches}
                          articleIndex={index + 1}
                          isTablet={isTablet}
                          commentsCount={this.getCommentsData(
                            val.id || val.msid,
                          )}
                          commentsData={this.getComments(val.id || val.msid)}
                          sectionName={this.getArticleSectionName(
                            photostoryMsid,
                          )}
                          isPrivateUser={this.props.isPrivateUser}
                          openSideBar={this.openPSSideBar}
                          showFontAlterOptions={false}
                          rhsWidgetPriorityPS={this.props.rhsWidgetPriorityPS}
                          currentCountry={this.props.currentCountry}
                          rhsWidgetVideoAutoplay={
                            this.props.rhsWidgetVideoAutoplay
                          }
                          articleWidget={this.props.articleWidget}
                          photostoryWidget={this.props.photostoryWidget}
                          navsubsecs={parentPhotostoryData.navsubsecs}
                          isAdRemoved={this.props.isAdRemoved}
                          bottomWidgets={this.props.widgets}
                          isEtimesPhotostory={this.props.isEtimesPhotostory}
                          earnPoints={this.props.earnPoints}
                          user={this.props.userData}
                          isPerpetual
                        />
                      </>
                    )}
                  {index === nextLinksData.length - 1 ? (
                    <div
                      id={`next-story-${nextLinksData[index].msid}`}
                      data-linkindex={`${index + 1}`}
                      data-prevlinkindex={`${index - 1}`}
                      style={{ display: 'none' }}
                    />
                  ) : null}
                </div>
              ))
            : null}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  navigation: state.header.data && state.header.data.navigation,
  articleWidget:
    state.commonData &&
    state.commonData.data &&
    state.commonData.data.articleWidget,
  photostoryWidget:
    state.commonData &&
    state.commonData.data &&
    state.commonData.data.photostoryWidget,
  comments: state.comments,
  isPrivateUser: state.gdpr.isPrivateUser,
  sidebarData: state.sidebar ? state.sidebar.data : {},
  currentCountry: state.geo.currentCountry,
  photostories: state.photostory.data,
  userData: state.login?.userData,
});

const mapDispatchToProps = dispatch => ({
  openSidebar: (params, id) => {
    dispatch(openSidebar(params, id));
  },
  loadPhotostoryData: (params, isAppView) => {
    dispatch(loadPhotostoryData(params, isAppView));
  },
  earnPoints: data => {
    dispatch(earnAboundPoints(data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PhotostoryWrapper);
